import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        inverse: Boolean,
        center: Boolean,
        justifyCenter: Boolean,
        small: Boolean,
        full: Boolean,
    },
});
